import { CommonModule } from '@angular/common';
import { Component, Inject, Input, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ButtonComponent, ButtonStyle } from 'src/app/components/button/button.component';
import { IconName } from 'src/app/components/icon/icons/icon-map';
import { IconComponent } from 'src/app/components/icon/icon.component';

type DialogButtonProps = {
  id?: string;
  text?: string;
  style?: ButtonStyle;
  icon?: IconName;
  disabled?: boolean;
  action?: () => void;
  hide?: boolean;
};

export type ConfirmationDialogProps = {
  id?: string;
  title: string;
  message?: string;
  contentTemplate?: TemplateRef<any>;
  cancelButton?: DialogButtonProps;
  confirmButton?: DialogButtonProps;
};

export const ConfirmDialogResult = {
  Confirm: 'confirm',
  Cancel: 'cancel',
} as const;

type ObjectValues<T> = T[keyof T];
export type ConfirmDialogResultType = ObjectValues<typeof ConfirmDialogResult>;

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  imports: [CommonModule, MatDialogModule, MatButtonModule, ButtonComponent, IconComponent],
})
export class ConfirmationDialogComponent {
  @Input() props: ConfirmationDialogProps;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent, ConfirmDialogResultType>,
    @Inject(MAT_DIALOG_DATA) private readonly data: ConfirmationDialogProps,
  ) {
    this.props = data;
  }

  get confirmButtonText() {
    return this.props?.confirmButton?.text || 'Confirmar';
  }

  get cancelButtonText() {
    return this.props?.cancelButton?.text || 'Cancelar';
  }

  getConfirmButtonStyle(): ButtonStyle {
    return this.props?.confirmButton?.style || 'default';
  }

  getCancelButtonStyle(): ButtonStyle {
    return this.props?.cancelButton?.style || 'outline';
  }

  handleCancel() {
    const { cancelButton } = this.props;
    cancelButton?.action ? cancelButton.action() : this.dialogRef.close('cancel');
  }

  handleConfirm() {
    const { confirmButton } = this.props;
    confirmButton?.action ? confirmButton.action() : this.dialogRef.close('confirm');
  }

  handleClose() {
    this.dialogRef.close('cancel');
  }
}
